export default __webpack_public_path__ + "static/media/BurfordRusticBook-Regular2.3ecf2a91.otf";